export default {
  loading: false,
  loadingBinnacle: false,
  successAction: false,
  error: '',
  showModal: false, // TODO: delete this.
  list: {}, // TODO: <-
  details: {
    dnt: {},
    comentarios: [],
    cuerpo: '',
    adjuntos: []
  },
  comments: [],
  binnacle: [],
  timeline: [],
  wizardData: {},
  wizardStorage: {},
  selectedFile: {},
  activities: [],
  activitiesHistory: [],
  references: [],
  referencesByType: [],
  pagination: {
    items: 0,
    pages: 0
  },
  loadingDocs: false,
  communes: [],
  documentTypeSelected: {},
  documentsOptions: []
};
